import React from "react";
import { Link } from "react-router-dom";

export default function AdminHome() {
  return (
    <div className="admin">
      <h1>Wedding admin</h1>
      <p className="muted">Just for Ryan &amp; Lily.</p>
      <div className="admin-grid">
        <Link to="/admin/expenses" className="admin-card">
          <h2>Expenses</h2>
          <p>Plan and track spending across vendors.</p>
        </Link>
        <Link to="/admin/guests" className="admin-card">
          <h2>Guests</h2>
          <p>Manage the invite list and plus-ones.</p>
        </Link>
        <Link to="/admin/settings" className="admin-card">
          <h2>Settings</h2>
          <p>Dinner options and RSVP-by date.</p>
        </Link>
      </div>
    </div>
  );
}
